import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar, Popover} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, buttonField} from '../../core/redux/form'
import extract from '../../core/extract'
import {autocompleteMatcher, displayPrediction, highlightPrediction, addressField} from '../../core/google/places'
import Icon from '../../core/components/Icon'
import LoaderButton from '../../core/components/LoaderButton'
import ButtonToggle from '../../core/components/ButtonToggle'
import TypeaheadInput from '../../core/components/TypeaheadInput'
import {UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_UPDATED, sendUpdatePatrimonyContactIdentityCmd, updateUpdatePatrimonyContactIdentityCmd, loadContact} from '../actions'
import {UpdatePatrimonyContactIdentityCmd} from '../models'
import i18n from '../i18n'

class UpdatePatrimonyContactIdentityPopover extends Component {
    static propTypes = {
        onHide: PropTypes.func.isRequired
    }


    componentWillMount() {
        const {dispatch, contact} = this.props

        dispatch(updateUpdatePatrimonyContactIdentityCmd({
            company: contact.company,
            namez: contact.name,
            address: contact.address
        }))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.contact != this.props.contact) {
            const {dispatch, contact} = nextProps

            dispatch(updateUpdatePatrimonyContactIdentityCmd({
                company: contact.company,
                namez: contact.name,
                address: contact.address
            }))
        }
    }

    _sendCmd() {
        const {dispatch, onHide} = this.props

        return dispatch(sendUpdatePatrimonyContactIdentityCmd()).then(() => {
            return dispatch(loadContact())
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, form, cmd, contact, onHide, ...others} = this.props

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const addressTypeaheadButton = () => {
            if (cmd && cmd.address) {
                return (
                    <Button
                        {...buttonField(form.address(), null)}>
                        <Icon icon='minus' size='xs' />
                    </Button>
                )
            }
            return (
                <Button>
                    <Icon icon='plus' size='xs' />
                </Button>
            )
        }

        return (
            <Popover
                title={i18n.updatePatrimonyContact}
                {...others}>
                <form className='form-horizontal'>
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='company'
                        label={i18n.company}
                        {...form.namez.company()} />
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='select'
                        name='gender'
                        label={i18n.gender}
                        {...form.namez.gender()}>
                        <option value=''></option>
                        <option value='Male'>{i18n.genderEnum.male}</option>
                        <option value='Female'>{i18n.genderEnum.female}</option>
                    </Input>
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='firstName'
                        label={requiredLabel(i18n.firstName)}
                        {...form.namez.firstName()} />
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='lastName'
                        label={requiredLabel(i18n.lastName)}
                        {...form.namez.lastName()} />
                </form>
                <h5>{i18n.address}</h5>
                <form>
                    <Row>
                        <Col xs={4}>
                            <Input
                                type='text'
                                name='digicode'
                                placeholder={i18n.addressDigicode}
                                {...form.address.digicode()} />
                        </Col>
                        <Col xs={4}>
                            <Input
                                type='text'
                                name='staircase'
                                placeholder={i18n.addressStaircase}
                                {...form.address.staircase()} />
                        </Col>
                        <Col xs={4}>
                            <Input
                                type='text'
                                name='floor'
                                placeholder={i18n.addressFloor}
                                {...form.address.floor()} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <TypeaheadInput
                                ref='typeahead'
                                source={autocompleteMatcher}
                                display={displayPrediction}
                                highlight={highlightPrediction}
                                placeholder={i18n.addAddress}
                                buttonAfter={addressTypeaheadButton()}
                                {...addressField(form.address())} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={4}>
                            <Input disabled
                                type='text'
                                name='number'
                                placeholder={i18n.addressNumber}
                                {...form.address.number()} />
                        </Col>
                        <Col xs={8}>
                            <Input disabled
                                type='text'
                                name='street'
                                placeholder={i18n.addressStreet}
                                {...form.address.street()} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={4}>
                            <Input disabled
                                type='text'
                                name='zipCode'
                                placeholder={i18n.addressZipCode}
                                {...form.address.zipCode()} />
                        </Col>
                        <Col xs={8}>
                            <Input disabled
                                type='text'
                                name='city'
                                placeholder={i18n.addressCity}
                                {...form.address.city()} />
                        </Col>
                    </Row>
                </form>
                <ButtonToolbar>
                    <LoaderButton
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid()})}
                        onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.save}
                    </LoaderButton>
                    <Button
                        bsSize='large'
                        onClick={onHide}>
                        {i18n.cancel}
                    </Button>
                </ButtonToolbar>
            </Popover>
        )
    }
}

UpdatePatrimonyContactIdentityPopover = connectForm({
    target: 'cmd',
    schema: UpdatePatrimonyContactIdentityCmd.schema,
    action: UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_UPDATED
})(UpdatePatrimonyContactIdentityPopover)

UpdatePatrimonyContactIdentityPopover = connect((state) => ({
    cmd: state.patrimony.updatePatrimonyContactIdentityCmd,
    contact: state.patrimony.contact.contact
}))(UpdatePatrimonyContactIdentityPopover)

export default UpdatePatrimonyContactIdentityPopover


// WEBPACK FOOTER //
// ./lib/patrimony/components/UpdatePatrimonyContactIdentityPopover.js